import { CheckmarkIcon, CancelIcon } from '@forgeglobal/design-framework';
import { StepIconProps } from '@mui/material';
import { useStyles } from './style';
import cs from 'classnames';

const StepIcon = ({ active, completed, error }: StepIconProps) => {
  const classes = useStyles();

  if (error) {
    return (
      <CancelIcon
        className={classes.stepIconError}
        color="primary"
        fontSize="small"
      />
    );
  }

  if (completed) {
    return (
      <CheckmarkIcon
        className={classes.stepIconChecked}
        color="primary"
        fontSize="small"
      />
    );
  }

  if (active) {
    return (
      <div
        className={cs(classes.stepIconCircle, classes.stepIconCircleActive)}
      />
    );
  }

  return <div className={classes.stepIconCircle} />;
};

export default StepIcon;
